const SUBDOMAIN_ZONES = [
  'finanzcheck.de',
  'finanzcheck-shared.de',
  'finanzcheck-stage.de',
  'smava.de',
  'smava-shared.de',
  'smava-stage.de'
]

export function isOriginTrusted(origin: string): boolean {
  try {
    const { hostname, protocol } = new URL(origin)
    if (protocol !== 'https:') return false
    return SUBDOMAIN_ZONES.some(
      (zone) => hostname === zone || hostname.endsWith(`.${zone}`)
    )
  } catch {
    return false
  }
}

export function getOriginFromUrl(url: string): string | null {
  try {
    const origin = new URL(url).origin
    return isOriginTrusted(origin) ? origin : null
  } catch {
    return null
  }
}

/**
 * Returns the validated parent origin using browser-enforced sources only.
 *
 * ancestorOrigins[0] is set by the browser and cannot be overridden by the
 * parent page's JavaScript. document.referrer is used as a fallback for
 * Firefox which does not support ancestorOrigins.
 *
 * Deliberately does NOT use navigation.parentUrl, which is obtained via a
 * Pollard postMessage exchange and can be spoofed by an untrusted embedder
 * responding with a trusted URL string.
 */
export function getBrowserParentOrigin(): string | null {
  // Primary: ancestorOrigins — Chrome, Edge, Safari (browser-enforced)
  const ancestorOrigin = window.location.ancestorOrigins?.[0]
  if (ancestorOrigin) {
    return isOriginTrusted(ancestorOrigin) ? ancestorOrigin : null
  }

  // Fallback: document.referrer — Firefox (affected by Referrer-Policy, fail-safe when empty)
  if (document.referrer) {
    return getOriginFromUrl(document.referrer)
  }

  return null
}
